export enum ETransportAccessibilityTab {
  Outside = 'outside',
  Inside = 'inside',
}
